export enum SelectMode
{
    Single = 1 ,
    Range = 2
}